import { Box, Typography } from "@mui/material"
import { Phone, Email } from "@mui/icons-material"

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        backgroundColor: "background.paper",
        borderTop: "1px solid #e0e0e0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          © 2024 ERP System. All rights reserved.
        </Typography>

        <Box sx={{ display: "flex", gap: 3, alignItems: "center" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, whiteSpace: "nowrap" }}>
            <Phone sx={{ fontSize: 16 }} />
            <Typography variant="body2" color="text.secondary">
              +880 1712-345678
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Email sx={{ fontSize: 16 }} />
            <Typography variant="body2" color="text.secondary">
              support@erpsystem.com
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Footer
